
import {
  IonContent,
  IonHeader,
  IonList,
  IonItem,
  IonThumbnail,
  IonButtons,
  IonButton,
  IonIcon,
  IonSkeletonText,
  IonLabel,
  IonPage,
  IonRefresher,
  IonRefresherContent,
  IonTitle,
  IonToolbar,
  onIonViewDidEnter,
} from "@ionic/vue";
import CoinItem from "@/components/CoinItem.vue";
import EmptyView from "@/components/EmptyView.vue";
import { defineComponent, ref } from "vue";
import { notificationsOutline, alertCircleOutline } from "ionicons/icons";
import CoinService from "@/services/CoinService";
import { CoinModel } from "@/models/CoinModel";
import { ViewState } from "@/enums/ViewState";

export default defineComponent({
  name: "CoinList",

  setup() {
    const ionRefresher = ref();

    const viewState = ref<ViewState>(ViewState.INITIAL);
    const coins = ref<CoinModel[]>([]);

    const onRefreshComplete = () => {
      ionRefresher.value.$el.complete();
    };

    const loadCoins = async () => {
      viewState.value = ViewState.LOADING;

      try {
        const { data } = await CoinService.load();
        coins.value = data;

        if (coins.value.length) {
          viewState.value = ViewState.CONTENT;
        } else {
          viewState.value = ViewState.EMPTY;
        }  
        
      } catch {
        viewState.value = ViewState.ERROR;
      } finally {
        onRefreshComplete();
      }
    };

    const onReload = () => {
      loadCoins();
    };

    onIonViewDidEnter(() => {
      if (viewState.value !== ViewState.CONTENT) {
        loadCoins();
      }
    });

    return {
      viewState,
      ViewState,
      onReload,
      coins,
      ionRefresher,
      notificationsOutline,
      alertCircleOutline,
    };
  },
  components: {
    IonContent,
    IonHeader,
    IonList,
    IonItem,
    IonThumbnail,
    IonButtons,
    IonButton,
    IonIcon,
    IonSkeletonText,
    IonLabel,
    IonPage,
    IonRefresher,
    IonRefresherContent,
    IonTitle,
    IonToolbar,
    CoinItem,
    EmptyView,
  },
});
